import React from "react";
import { checkPropTypes } from "prop-types";

function SearchBlog(props) {
  return (
    <React.Fragment>
      <input
        aria-label="Search my journal"
        className="search-blog"
        type="text"
        placeholder="Search journal..."
        onChange={e => props.onChange(e)}
        value={props.value}
      />
    </React.Fragment>
  );
}

export default SearchBlog;
